<!-- src/components/CollapsibleSection.vue -->
<template>
  <div class="collapsible-section">
    <!-- Header (sidebar expandido) -->
    <div
      v-if="!sidebarCollapsed"
      class="collapsible-header"
      :class="{ 'collapsible-header-open': isOpen }"
      :style="{ paddingLeft: (level * 14 + 12) + 'px' }"
      @click="toggleSection"
    >
      <div class="collapsible-header-content">
        <Icon
          :icon="icon"
          width="20"
          height="20"
          class="collapsible-icon"
          :class="isOpen ? 'collapsible-icon-open' : ''"
        />
        <span class="collapsible-title" :class="isOpen ? 'collapsible-title-open' : ''">
          {{ title }}
        </span>
      </div>
      <Icon
        :icon="isOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'"
        width="18"
        height="18"
        class="collapsible-chevron"
        :class="isOpen ? 'collapsible-chevron-open' : ''"
      />
    </div>

    <!-- Versión colapsada (solo icono) -->
    <div
      v-else
      class="collapsible-collapsed"
      :class="{ 'collapsible-collapsed-open': isOpen }"
      @click="toggleSection"
      :title="title"
    >
      <Icon
        :icon="icon"
        width="22"
        height="22"
        :class="isOpen ? 'collapsible-icon-open' : ''"
      />
    </div>

    <!-- Submenú sin overflow:hidden y sin touch-action -->
    <div
      v-show="isOpen && !sidebarCollapsed"
      class="collapsible-content"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";

export default {
  name: 'CollapsibleSection',
  components: { Icon },
  emits: ['section-opened', 'toggle'],
  props: {
    title:            { type: String,  required: true },
    icon:             { type: String,  required: true },
    collapsed:        { type: Boolean, default: false },
    initialOpen:      { type: Boolean, default: false },
    sidebarCollapsed: { type: Boolean, default: false },
    name:             { type: String,  default: '' },
    activeSection:    { type: String,  default: null },
    level:            { type: Number,  default: 0 }
  },
  data() {
    return { isOpen: this.initialOpen };
  },
  watch: {
    sidebarCollapsed: {
      handler(newVal) {
        if (newVal) this.isOpen = false;
      }
    },
    initialOpen: {
      handler(newVal) {
        if (newVal && !this.sidebarCollapsed) {
          this.isOpen = true;
          if (this.name) this.$emit('section-opened', this.name);
        }
      }
    },
    activeSection: {
      handler(newVal) {
        if (!newVal || !this.name) return;
        if (newVal === this.name) return;
        const nuevoNivel = this.extraerNivel(newVal);
        if (nuevoNivel === this.level) {
          this.isOpen = false;
        }
      }
    }
  },
  methods: {
    toggleSection() {
      if (!this.sidebarCollapsed) {
        this.isOpen = !this.isOpen;
        this.$emit('toggle', this.isOpen);
        if (this.isOpen && this.name) {
          this.$emit('section-opened', this.name);
        }
      }
    },
    extraerNivel(name) {
      const match = String(name).match(/section-L(\d+)-/);
      return match ? parseInt(match[1]) : -1;
    }
  }
};
</script>

<style scoped>
.collapsible-section {
  margin-bottom: 4px;
  min-width: 0;
}

/* HEADER */
.collapsible-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  border-left: 4px solid transparent;
  transition: background-color 0.15s, border-color 0.15s;
}
.collapsible-header:hover { background: #f3f4f6; }
.collapsible-header-open {
  background: #eff6ff;
  border-left-color: #2563eb;
}
.dark .collapsible-header:hover { background: #374151; }
.dark .collapsible-header-open {
  background: rgba(37, 99, 235, 0.15);
  border-left-color: #3b82f6;
}

.collapsible-header-content {
  display: flex;
  align-items: center;
  min-width: 0;
}

.collapsible-icon { flex-shrink: 0; color: #475569; }
.collapsible-icon-open { color: #2563eb; }
.dark .collapsible-icon { color: #94a3b8; }
.dark .collapsible-icon-open { color: #60a5fa; }

.collapsible-title {
  margin-left: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.collapsible-title-open { color: #1d4ed8; font-weight: 700; }
.dark .collapsible-title { color: #e2e8f0; }
.dark .collapsible-title-open { color: #93c5fd; }

.collapsible-chevron { flex-shrink: 0; color: #9ca3af; }
.collapsible-chevron-open { color: #2563eb; }
.dark .collapsible-chevron { color: #6b7280; }
.dark .collapsible-chevron-open { color: #60a5fa; }

/* VERSIÓN COLAPSADA */
.collapsible-collapsed {
  display: flex;
  justify-content: center;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  border-left: 4px solid transparent;
}
.collapsible-collapsed:hover { background: #f3f4f6; }
.collapsible-collapsed-open {
  background: #eff6ff;
  border-left-color: #2563eb;
}
.dark .collapsible-collapsed:hover { background: #374151; }
.dark .collapsible-collapsed-open {
  background: rgba(37, 99, 235, 0.15);
  border-left-color: #3b82f6;
}

/* CONTENIDO */
.collapsible-content {
  margin-top: 4px;
  min-width: 0;
}
</style>